'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { RequestStatusPropType } from 'developer-docs-shared-components/lib/models/RequestStatus';
import { parse as parseQuery } from 'hub-http/helpers/params';
import { EVENTS } from '../../../tracking/events';
import { fetchCustomSpecification } from 'developer-docs-shared-components/modules/Doc/actions';
import { getOasDocs, getSpecificationStatus, getSpecificationWithExtensions } from 'developer-docs-shared-components/modules/Doc/selectors/DocSelectors';
import LoadingHOC from 'developer-docs-shared-components/lib/hoc/LoadingHOC';
import DeveloperDoc from 'developer-docs-shared-components/modules/Doc/components/DeveloperDoc';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { getUsageTracker } from 'developer-docs-shared-components/tracking/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
class ApiDeveloperDoc extends Component {
  constructor(props) {
    super(props);
    const query = parseQuery(props.location.search.slice(1));
    this.specUrl = query.url;
    this.internal = !!query.internal && query.internal === 'true';
    this.tracker = getUsageTracker();
  }
  componentDidMount() {
    this.tracker.track(EVENTS.PAGEVIEW, {
      screen: 'custom documentation',
      url: this.specUrl
    });
    if (window.newrelic) {
      // New Relic strips out query parameters, so to segment pages we need to use custom attributes
      window.newrelic.setCustomAttribute('specification', this.specUrl);
    }
    this.props.fetchCustomSpecification(this.specUrl, this.internal);
  }
  render() {
    const {
      loadingStatus,
      oasDocs,
      specWithExtensions
    } = this.props;
    return /*#__PURE__*/_jsx(LoadingHOC, {
      statuses: [loadingStatus],
      error: /*#__PURE__*/_jsx(NavMarker, {
        name: "CUSTOM_PAGE_ERROR",
        children: /*#__PURE__*/_jsx(UIErrorMessage, {})
      }),
      children: loadingStatus.succeeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "CUSTOM_PAGE_LOAD",
        children: /*#__PURE__*/_jsx(DeveloperDoc, {
          oasDocs: oasDocs,
          specWithExtensions: specWithExtensions
        })
      })
    });
  }
}
ApiDeveloperDoc.propTypes = {
  fetchCustomSpecification: PropTypes.func.isRequired,
  loadingStatus: RequestStatusPropType.isRequired,
  location: PropTypes.object.isRequired,
  oasDocs: PropTypes.array,
  specWithExtensions: PropTypes.object
};
const mapStateToProps = state => {
  return {
    loadingStatus: getSpecificationStatus(state),
    oasDocs: getOasDocs(state),
    specWithExtensions: getSpecificationWithExtensions(state)
  };
};
const mapDispatchToProps = {
  fetchCustomSpecification
};
export default connect(mapStateToProps, mapDispatchToProps)(ApiDeveloperDoc);